import Tree from "modules/ProjectFiles/Tree";
import { CircularProgress, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useGetProjectFiles } from "hooks/projectFiles/useGetProjectFiles";
import ProjectFilesContextProvider from "modules/proposals/providers/ProjectFilesContextProvider";
import FileDetails from "modules/ProjectFiles/FileDetails";

export default function ProjectFileExplorer({
  fileView,
  folderView,
  folderId,
  enableSelectFile = false,
  hideAddFile = false,
  allowMultiSelect = false,
  initialSelectedItems = null,
  showSubmitButton,
  selectionMode = "default",
  mode = "browse",
  submitLabel = "Select",
  height,
  submitFn,
}: {
  fileView?: boolean;
  folderView?: boolean;
  folderId?: string | number | null;
  enableSelectFile?: boolean;
  hideAddFile?: boolean;
  allowMultiSelect?: boolean;
  initialSelectedItems?: string | string[] | null;
  showSubmitButton?: boolean;
  selectionMode?: "default" | "folder";
  mode?: "browse" | "folder-select" | "file-attach";
  submitLabel?: string;
  height?: string | number;
  submitFn?: (folderId: string | string[]) => void;
}) {
  const { data, loading } = useGetProjectFiles();
  const shouldShowSubmitButton = mode === "folder-select" ? showSubmitButton ?? true : false;
  const isFileAttachMode = mode === "file-attach";

  return (
    <>
      {loading && <CircularProgress />}
      {data && (
        <ProjectFilesContextProvider initialSelectedItems={initialSelectedItems}>
          <MDBox mt={1} mb={0} sx={{ height }}>
            <Grid container spacing={0} sx={{ height: "100%" }}>
              {!fileView && (
                <Grid
                  item
                  xs={12}
                  md={folderView ? 12 : isFileAttachMode ? 4 : 4}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                    height: "100%",
                    overflow: "hidden",
                    maxWidth: {
                      md: isFileAttachMode ? "340px" : undefined,
                    },
                    flexBasis: {
                      md: isFileAttachMode ? "340px" : undefined,
                    },
                  }}
                >
                  <Tree
                    data={data}
                    submitFn={submitFn}
                    folderView={folderView}
                    enableSelectFile={enableSelectFile}
                    hideAddFile={hideAddFile}
                    allowMultiSelect={allowMultiSelect}
                    selectionMode={selectionMode}
                    showSubmitButton={shouldShowSubmitButton}
                    submitLabel={submitLabel}
                    mode={mode}
                  />
                </Grid>
              )}

              {!folderView && !(fileView && !folderId) && (
                <Grid
                  item
                  xs={12}
                  md={fileView ? 12 : isFileAttachMode ? true : 7}
                  ml={3}
                  pl={4}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    minHeight: 0,
                    flex: 1,
                    overflow: "hidden",
                  }}
                >
                  <FileDetails
                    data={data}
                    fileView={fileView}
                    folderId={folderId}
                    enableSelectFile={enableSelectFile}
                    allowMultiSelect={allowMultiSelect}
                    submitFn={submitFn}
                    mode={mode}
                  />
                </Grid>
              )}
            </Grid>
          </MDBox>
        </ProjectFilesContextProvider>
      )}
    </>
  );
}
